<div class="navbar-custom">
  <div class="container">
    <div id="navigation" [class.open]="opened()">
      <ul class="navigation-menu" data-cy="menu">
        @for (category of navigationItems; track category; let index = $index) {
          @if (category.visible) {
            <li
              class="has-submenu first treeview {{ category.classList }}"
              #myDiv
              [class.open.active]="category.expanded"
              data-cy="category"
            >
              <ng-container>
                @if (category.url) {
                  <a
                    class="toggle-submenu submenu-{{ index }}"
                    [href]="category.url"
                  >
                    @if (category.icon) {
                      <span>
                        <i class="{{ category.icon }}"></i>
                        {{ category.label }}
                      </span>
                    }
                  </a>
                }
                @if (category.routerLink) {
                  <a
                    class="toggle-submenu submenu-{{ index }}"
                    [routerLink]="category.routerLink"
                    routerLinkActive="active"
                  >
                    @if (category.icon) {
                      <span>
                        <i class="{{ category.icon }}"></i>
                        {{ category.label }}
                      </span>
                    }
                  </a>
                }
                @if (!category.routerLink && !category.url) {
                  <a
                    aria-hidden="true"
                    (click)="myDiv.classList.toggle('opened')"
                    class="toggle-submenu submenu-{{ index }}"
                  >
                    @if (category.icon) {
                      <span>
                        <i class="{{ category.icon }}"></i>
                        {{ category.label }}
                        @if (0 < getVisibleItemsCount(category.items)) {
                          <i class="pi pi-angle-down submenu-arrow"></i>
                        }
                      </span>
                    }
                  </a>
                }
              </ng-container>
              @if (0 < getVisibleItemsCount(category.items)) {
                <ul
                  class="treeview-menu submenu megamenu"
                  [class.open]="category.expanded"
                  data-cy="category-submenu"
                >
                  @for (link of category.items; track link) {
                    @if (link.visible) {
                      <li data-cy="category-submenu-item">
                        @if (link.url) {
                          <a [href]="link.url" class="submenu-item">
                            {{ link.label }}
                          </a>
                        }
                        @if (link.routerLink) {
                          <a
                            [routerLink]="
                              isLinkNotActive(link) ? null : link.routerLink
                            "
                            [class.not-active]="isLinkNotActive(link)"
                            class="submenu-item"
                            routerLinkActive="active"
                          >
                            {{ link.label }}
                          </a>
                        }
                        @if (link.callback) {
                          <a
                            aria-hidden="true"
                            (click)="
                              isLinkNotActive(link)
                                ? null
                                : callMethod(link.callback)
                            "
                            [class.not-active]="isLinkNotActive(link)"
                            [class.active]="isCallbackActive(link)"
                            class="submenu-item"
                          >
                            {{ link.label }}
                          </a>
                        }
                      </li>
                    }
                  }
                </ul>
              }
            </li>
          }
        }
      </ul>
      <!-- End navigation menu  -->
    </div>
  </div>
</div>
